<template>
    <div class="box">
        <NOTHAVEPRIZE :list='list'/>
    </div>
</template>

<script>
import NOTHAVEPRIZE from './components/notHavePrize.vue'
import { getRecordList } from '@/api/api'
import { get } from '../../../utils/token'
export default {
  components: {
    NOTHAVEPRIZE
  },
  data () {
    return {
      mobile: get('mobile'),
      list: []
    }
  },
  mounted () {
    this.getRecordListdata()
  },
  methods: {
    async getRecordListdata () {
      try {
        const result = await getRecordList(this.mobile)
        if (result.code === 200) {
          this.list = result.list
        } else {
          this.$toast.error('获取数据失败!')
        }
      } catch (error) {
        this.$toast.error('获取数据失败!')
      }
    }
  }
}
</script>

<style lang="scss" scoped>
</style>
